import React from 'react';
import { Helmet } from 'react-helmet';

import PageContext from '../components/PageContext/PageContext';

import renderStoryblokComponents from '../utils/renderStoryblokComponents';

export default class StoryblokPage extends React.Component {
  render() {
    let content = this.props.content;
    return (
      <>
        <Helmet>
          {content.locale && <html lang={content.locale} />}
          <title>{`${content.title} - Founders Factory`}</title>
          <meta name="description" content={content.description} />
          <meta
            name="google-site-verification"
            content="KnvOzhLhiv8Rv_GlaRfoF1hMajwBFj-RDzU3YOBCOZA"
          />
          <meta name="twitter:card" content="summary" />
          <meta name="twitter:site" content="@foundersfactory" />
          <meta
            property="og:image"
            content={content.og_image || 'https://foundersfactory.com/logo.png'}
          />
          {content.og_title && (
            <meta property="og:title" content={content.og_title} />
          )}
          {content.og_description && (
            <meta property="og:description" content={content.og_description} />
          )}
        </Helmet>
        <PageContext>
          {content.body && content.body.length ? (
            renderStoryblokComponents({ blocks: content.body })
          ) : (
            <div></div>
          )}
        </PageContext>
      </>
    );
  }
}
